export default __webpack_public_path__ + "static/media/hexagons-welcome.13cd5bf1.svg";